import React from "react";
import { HeroBg } from "../Assets";
import StaticsImages from "./Statics";
import { TProductDetail } from "../../types";

const Right = ({ products }: { products?: TProductDetail[] }) => {
  return (
    <div className="relative items-center flex-1 hidden py-2 lg:flex">
      <img
        src={HeroBg}
        alt=""
        className="ml-auto lg:h-[550px] h-[420px] w-full lg:w-auto"
      />
      <StaticsImages products={products} />
    </div>
  );
};

export default Right;
